import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import careers from "../../data/careers";

const CSS = `
  .pf-detail { min-height: 100vh; padding: 110px 0 80px; position: relative; }
  .pf-detail-wrap { max-width: 800px; margin: 0 auto; padding: 0 24px; position: relative; z-index: 1; }

  .pf-detail-back {
    display: inline-flex; align-items: center; gap: 8px; margin-bottom: 28px;
    font-size: 0.84em; font-weight: 600; color: rgba(240,240,245,0.35);
    text-decoration: none; transition: all 0.25s ease;
  }
  .pf-detail-back:hover { color: #FF6B35; transform: translateX(-4px); }

  .pf-detail-hero {
    padding: 40px; border-radius: 24px; margin-bottom: 36px;
    border: 1px solid rgba(255,255,255,0.05);
    position: relative; overflow: hidden;
    animation: fadeInUp 0.6s ease both;
  }
  .pf-detail-hero-top { display: flex; align-items: center; gap: 18px; margin-bottom: 18px; }
  .pf-detail-icon {
    width: 70px; height: 70px; border-radius: 22px;
    display: flex; align-items: center; justify-content: center;
    font-size: 2.2em; flex-shrink: 0;
  }
  .pf-detail-title {
    font-family: 'DM Serif Display', serif; font-size: clamp(1.5em, 3vw, 2em);
    color: #F0F0F5;
  }
  .pf-detail-tagline { font-size: 0.88em; color: rgba(240,240,245,0.4); margin-top: 4px; }
  .pf-detail-desc { font-size: 0.92em; color: rgba(240,240,245,0.5); line-height: 1.8; }

  /* sections */
  .pf-detail-section {
    margin-bottom: 32px; padding: 28px; border-radius: 20px;
    background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.04);
    animation: fadeInUp 0.6s ease both;
  }
  .pf-detail-sh {
    display: flex; align-items: center; gap: 10px; margin-bottom: 18px;
  }
  .pf-detail-sh-icon {
    width: 36px; height: 36px; border-radius: 10px;
    display: flex; align-items: center; justify-content: center;
    font-size: 1em; flex-shrink: 0;
  }
  .pf-detail-sh-title { font-weight: 800; font-size: 1em; color: #F0F0F5; }

  .pf-detail-list { list-style: none; padding: 0; margin: 0; }
  .pf-detail-list li {
    padding: 10px 0; border-bottom: 1px solid rgba(255,255,255,0.03);
    font-size: 0.88em; color: rgba(240,240,245,0.55); line-height: 1.6;
    display: flex; align-items: flex-start; gap: 10px;
  }
  .pf-detail-list li:last-child { border-bottom: none; }
  .pf-detail-list li::before {
    content: '›'; color: #FF6B35; font-weight: 700; flex-shrink: 0; margin-top: 1px;
  }

  /* skills */
  .pf-detail-skills { display: flex; flex-wrap: wrap; gap: 8px; }
  .pf-detail-skill {
    padding: 6px 16px; border-radius: 20px; font-size: 0.78em; font-weight: 600;
    background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.06);
    color: rgba(240,240,245,0.55); transition: all 0.25s ease;
  }
  .pf-detail-skill:hover { background: rgba(255,107,53,0.08); border-color: rgba(255,107,53,0.2); color: #FF6B35; }

  /* salary */
  .pf-detail-salary-grid {
    display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px;
  }
  .pf-detail-salary-card {
    padding: 18px 14px; border-radius: 14px; text-align: center;
    background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.04);
    transition: all 0.3s ease;
  }
  .pf-detail-salary-card:hover { background: rgba(255,255,255,0.04); transform: translateY(-4px); }
  .pf-detail-salary-label {
    font-size: 0.68em; font-weight: 600; letter-spacing: 1px; text-transform: uppercase;
    color: rgba(240,240,245,0.3); margin-bottom: 6px;
  }
  .pf-detail-salary-val {
    font-family: 'JetBrains Mono', monospace; font-weight: 700; font-size: 1.1em;
  }

  /* roadmap */
  .pf-detail-roadmap { display: flex; flex-direction: column; gap: 0; }
  .pf-detail-rm-step {
    display: flex; gap: 16px; position: relative; padding-bottom: 24px;
  }
  .pf-detail-rm-step:last-child { padding-bottom: 0; }
  .pf-detail-rm-line {
    width: 2px; flex-shrink: 0; position: relative;
    display: flex; flex-direction: column; align-items: center;
  }
  .pf-detail-rm-dot {
    width: 14px; height: 14px; border-radius: 50%; flex-shrink: 0;
    border: 2px solid; position: relative; z-index: 1;
  }
  .pf-detail-rm-connector {
    flex: 1; width: 2px; margin-top: 4px;
    background: linear-gradient(180deg, rgba(255,255,255,0.06), transparent);
  }
  .pf-detail-rm-content { flex: 1; padding-top: 0; }
  .pf-detail-rm-label { font-weight: 700; font-size: 0.88em; color: #F0F0F5; margin-bottom: 4px; }
  .pf-detail-rm-text { font-size: 0.82em; color: rgba(240,240,245,0.42); line-height: 1.6; }

  /* colleges */
  .pf-detail-colleges { display: flex; flex-wrap: wrap; gap: 8px; }
  .pf-detail-college {
    padding: 8px 16px; border-radius: 12px; font-size: 0.8em; font-weight: 600;
    background: rgba(0,212,170,0.06); border: 1px solid rgba(0,212,170,0.12);
    color: rgba(0,212,170,0.7);
  }

  .pf-detail-growth {
    font-size: 0.9em; color: rgba(240,240,245,0.45); line-height: 1.75;
    padding: 16px 20px; border-radius: 14px;
    background: rgba(255,210,63,0.04); border: 1px solid rgba(255,210,63,0.1);
  }

  .pf-detail-cta { text-align: center; margin-top: 40px; }

  @media(max-width: 600px) {
    .pf-detail-salary-grid { grid-template-columns: 1fr; }
    .pf-detail-hero { padding: 24px 20px; }
  }
`;

const ROADMAP_COLORS = ["#FF6B35", "#FFD23F", "#00D4AA", "#7C5CFC", "#FF4D6A"];

export default function CareerDetail() {
  const { careerId } = useParams();
  const career = careers.find((c) => c.id === careerId);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [careerId]);

  if (!career) {
    return (
      <section className="pf-detail">
        <div
          className="pf-detail-wrap"
          style={{ textAlign: "center", paddingTop: 80 }}
        >
          <span style={{ fontSize: "3em", display: "block", marginBottom: 16 }}>
            🔍
          </span>
          <h1 className="section-title">Career Not Found</h1>
          <p style={{ color: "rgba(240,240,245,0.4)", marginBottom: 24 }}>
            We couldn't find that career path.
          </p>
          <Link to="/careers" className="btn-primary">
            ← Back to Career Library
          </Link>
        </div>
      </section>
    );
  }

  return (
    <>
      <style>{CSS}</style>
      <section className="pf-detail">
        <div className="pf-detail-wrap">
          <Link to="/careers" className="pf-detail-back">
            ← Back to Career Library
          </Link>

          {/* Hero */}
          <div
            className="pf-detail-hero"
            style={{
              background: `${career.color}08`,
              borderColor: `${career.color}15`,
            }}
          >
            <div className="pf-detail-hero-top">
              <div
                className="pf-detail-icon"
                style={{
                  background: `${career.color}15`,
                  border: `1px solid ${career.color}25`,
                }}
              >
                {career.emoji}
              </div>
              <div>
                <h1 className="pf-detail-title">{career.title}</h1>
                <div className="pf-detail-tagline">{career.tagline}</div>
              </div>
            </div>
            <p className="pf-detail-desc">{career.description}</p>
          </div>

          {/* What They Do */}
          <div className="pf-detail-section" style={{ animationDelay: "0.1s" }}>
            <div className="pf-detail-sh">
              <div
                className="pf-detail-sh-icon"
                style={{
                  background: "rgba(255,107,53,0.1)",
                  border: "1px solid rgba(255,107,53,0.2)",
                }}
              >
                💼
              </div>
              <div className="pf-detail-sh-title">What They Do</div>
            </div>
            <ul className="pf-detail-list">
              {career.whatTheyDo.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

          {/* Skills */}
          <div
            className="pf-detail-section"
            style={{ animationDelay: "0.15s" }}
          >
            <div className="pf-detail-sh">
              <div
                className="pf-detail-sh-icon"
                style={{
                  background: "rgba(124,92,252,0.1)",
                  border: "1px solid rgba(124,92,252,0.2)",
                }}
              >
                🧠
              </div>
              <div className="pf-detail-sh-title">Required Skills</div>
            </div>
            <div className="pf-detail-skills">
              {career.skills.map((s, i) => (
                <span className="pf-detail-skill" key={i}>
                  {s}
                </span>
              ))}
            </div>
          </div>

          {/* Salary */}
          <div className="pf-detail-section" style={{ animationDelay: "0.2s" }}>
            <div className="pf-detail-sh">
              <div
                className="pf-detail-sh-icon"
                style={{
                  background: "rgba(255,210,63,0.1)",
                  border: "1px solid rgba(255,210,63,0.2)",
                }}
              >
                💰
              </div>
              <div className="pf-detail-sh-title">Salary Range (India)</div>
            </div>
            <div className="pf-detail-salary-grid">
              {[
                {
                  label: "Entry Level",
                  val: career.salaryRange.entry,
                  color: "#00D4AA",
                },
                {
                  label: "Mid Career",
                  val: career.salaryRange.mid,
                  color: "#FFD23F",
                },
                {
                  label: "Senior Level",
                  val: career.salaryRange.senior,
                  color: "#FF6B35",
                },
              ].map((s) => (
                <div className="pf-detail-salary-card" key={s.label}>
                  <div className="pf-detail-salary-label">{s.label}</div>
                  <div
                    className="pf-detail-salary-val"
                    style={{ color: s.color }}
                  >
                    {s.val}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Roadmap */}
          <div
            className="pf-detail-section"
            style={{ animationDelay: "0.25s" }}
          >
            <div className="pf-detail-sh">
              <div
                className="pf-detail-sh-icon"
                style={{
                  background: "rgba(0,212,170,0.1)",
                  border: "1px solid rgba(0,212,170,0.2)",
                }}
              >
                🗺️
              </div>
              <div className="pf-detail-sh-title">Career Roadmap from 10th</div>
            </div>
            <div className="pf-detail-roadmap">
              {career.roadmap.map((step, i) => (
                <div className="pf-detail-rm-step" key={i}>
                  <div className="pf-detail-rm-line">
                    <div
                      className="pf-detail-rm-dot"
                      style={{
                        borderColor: ROADMAP_COLORS[i % 5],
                        background: `${ROADMAP_COLORS[i % 5]}20`,
                      }}
                    />
                    {i < career.roadmap.length - 1 && (
                      <div className="pf-detail-rm-connector" />
                    )}
                  </div>
                  <div className="pf-detail-rm-content">
                    <div
                      className="pf-detail-rm-label"
                      style={{ color: ROADMAP_COLORS[i % 5] }}
                    >
                      {step.step}
                    </div>
                    <div className="pf-detail-rm-text">{step.detail}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Top Colleges */}
          <div className="pf-detail-section" style={{ animationDelay: "0.3s" }}>
            <div className="pf-detail-sh">
              <div
                className="pf-detail-sh-icon"
                style={{
                  background: "rgba(0,212,170,0.1)",
                  border: "1px solid rgba(0,212,170,0.2)",
                }}
              >
                🏫
              </div>
              <div className="pf-detail-sh-title">Top Colleges in India</div>
            </div>
            <div className="pf-detail-colleges">
              {career.topColleges.map((c, i) => (
                <span className="pf-detail-college" key={i}>
                  {c}
                </span>
              ))}
            </div>
          </div>

          {/* Growth */}
          <div
            className="pf-detail-section"
            style={{ animationDelay: "0.35s" }}
          >
            <div className="pf-detail-sh">
              <div
                className="pf-detail-sh-icon"
                style={{
                  background: "rgba(255,210,63,0.1)",
                  border: "1px solid rgba(255,210,63,0.2)",
                }}
              >
                📈
              </div>
              <div className="pf-detail-sh-title">Growth Outlook</div>
            </div>
            <div className="pf-detail-growth">{career.growthOutlook}</div>
          </div>

          {/* CTA */}
          <div className="pf-detail-cta">
            <Link to="/test" className="btn-primary">
              🧭 Is This Career Right for Me? Take the Test
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
